import { render } from "./Battle.vue?vue&type=template&id=6f3c6d8e"
import script from "./Battle.vue?vue&type=script&lang=js"
export * from "./Battle.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__